module.exports = __webpack_public_path__ + "static/media/add-icon-green.6866c10d.svg";